import React, { Component } from "react";
import PropTypes from "prop-types";

class Tab extends Component {
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    activeStyles: PropTypes.string.isRequired,
    inactiveStyles: PropTypes.string.isRequired,
    tabStyles: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  onClick = () => {
    const { label, onClick } = this.props;
    onClick(label);
  };

  render() {
    const {
      onClick,
      props: { activeTab, label, tabStyles, activeStyles, inactiveStyles },
    } = this;

    return (
        <div 
          className={`text-center flex-1 ${tabStyles} ${activeTab === label ? activeStyles : inactiveStyles }`} 
          onClick={onClick} 
          onKeyDown={onClick} 
          role="button" 
          tabIndex={label}
          aria-label="tab"
          dangerouslySetInnerHTML={{
            __html: label
            }} 
        />
    );
  }
}

export default Tab;